import React, {Suspense, useEffect, useState} from "react";
import * as ReactDOM from "react-dom";
import {LookDataType, LookItemType} from "./LookTypes";
import {fetchLook, ResponseError} from "./stlHelper";
import {PayPalLoadingSpinner} from "../../lib/payments/paypal/BraintreeButton";
import ErrorBoundary from "../../utils/ErrorBoundary";
import {useCustomerSelector} from "../../../store";
import {fetchProductsFromInternalApi} from "./stlHelper";

const LookDetail = React.lazy(() => import("./LookDetail"));

const LookPortal = () => {
  const lookDiv = document.getElementById("shop-the-look-detail");
  const [look, setLook] = useState<LookDataType | null>(null);
  const [isError, setIsError] = useState<boolean>(false);
  const {customer} = useCustomerSelector();
  const [lookItems, setLookItems] = useState<LookItemType[] | null>(null);

  useEffect(() => {
    if (!lookDiv) return;

    const startFetch = () => {
      const lookId = new URLSearchParams(window.location.search).get("look-id");

      void fetchLook(lookId)
        .then((lookData) => {
          if (lookData) {
            setLook(lookData);
          } else {
            setIsError(true);
          }
        })
        .catch((error: ResponseError) => {
          setIsError(true);
          if (__DEVELOPMENT__) {
            // eslint-disable-next-line no-console
            console.error("DEVELOP:", JSON.stringify(error.data));
          }
        });
    };

    startFetch();
    window.addEventListener("popstate", startFetch);

    return () => window.removeEventListener("popstate", startFetch);
  }, []);

  // fetch unserer shop-internen daten
  useEffect(() => {
    setLookItems(null);
    if (look) void fetchProductsFromInternalApi(look, customer).then(setLookItems);
  }, [look]);

  if (!lookDiv) {
    return null;
  }

  if (isError) {
    return ReactDOM.createPortal(<div>Leider ist etwas schiefgelaufen</div>, lookDiv);
  }

  if (!look || !lookItems) {
    return ReactDOM.createPortal(<PayPalLoadingSpinner />, lookDiv);
  }

  return ReactDOM.createPortal(
    <ErrorBoundary fallback={null} occurrence="LookDetail">
      <Suspense fallback={null}>
        <div className="stl-ldp-wrapper">
          <LookDetail look={look} lookItems={lookItems} isLookDetailPageItem={true} setLook={setLook} />
        </div>
      </Suspense>
    </ErrorBoundary>,
    lookDiv,
  );
};

export default LookPortal;
